import { InputBase, styled, alpha } from "@mui/material";

const MapitInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3),
    },
    borderRadius: 6,
    position: 'relative',
    backgroundColor: '#FFFFFF',
    border: '1px solid',
    borderColor: '#D0D5DD',
    padding: '10px 14px',
    transition: theme.transitions.create([
        'border-color',
        'background-color',
        'box-shadow',
    ]),
    ':focus-within': {
        boxShadow: `${alpha(theme.palette.primary.main, 0.1)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main,
    },
    '& .MuiInputBase-input': {
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 400,
        padding: 0,
    },
    // '& .MuiInputBase-input::placeholder': {
    //     color: '#DBDBDB',
    //     opacity: 1
    // },
}));

export default MapitInput;